var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "section" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.btnshowAWindow,
                  expression: "btnshowAWindow"
                }
              ],
              attrs: { type: "primary" },
              on: { click: _vm.showAWindowClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.ViewAssociatedBusiness")))]
          )
        ],
        1
      ),
      _c("div", { staticClass: "section" }, [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("SeaExport.DangerousGoods")))
        ]),
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "row" } },
          [
            _c(
              "el-form",
              {
                staticStyle: { display: "flex", "flex-direction": "column" },
                attrs: { "label-width": "190px", "label-position": "left" }
              },
              [
                _c(
                  "el-form-item",
                  { staticClass: "auto-width", attrs: { "label-width": "0" } },
                  [
                    _c("cargo-ag-grid", {
                      staticStyle: { width: "515px", height: "200px" },
                      attrs: {
                        "grid-options": _vm.danger.gridOptions,
                        "column-defs": _vm.dangerColumnDefs,
                        "row-data": _vm.specialGoods
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.danger.gridApi = params.api
                        }
                      }
                    }),
                    _c("div", { staticStyle: { width: "100%" } }, [
                      _c(
                        "div",
                        { staticStyle: { float: "right", padding: "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.isEditing
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addSpGoods()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SpecialGoods.Add")))]
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: {
                                type: "danger",
                                disabled: !_vm.isEditing
                              },
                              on: {
                                click: function($event) {
                                  return _vm.delSpGoods()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SpecialGoods.Delete")))]
                          ),
                          _c(
                            "el-upload",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "padding-left": "5px"
                              },
                              attrs: {
                                disabled: !_vm.isEditing,
                                action: "string",
                                "http-request": _vm.importSpGoods,
                                "show-file-list": false,
                                accept: ".jpg, .jpeg, .png",
                                "before-upload": _vm.beforeUploadSpgGoods
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: !_vm.isEditing,
                                    type: "primary"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SpecialGoods.Import")))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "5px" },
                              attrs: {
                                type: "primary",
                                disabled: !_vm.isEditing
                              },
                              on: {
                                click: function($event) {
                                  return _vm.fillInSpGoods()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SpecialGoods.FillIn")))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.CLASSNO") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danClassNo,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danClassNo", $$v)
                        },
                        expression: "editObj.danClassNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SpecialGoods.SecondarySpecialGoods")
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.secondarySpecialGoods,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "secondarySpecialGoods", $$v)
                        },
                        expression: "editObj.secondarySpecialGoods"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.UNNO") } },
                  [
                    _c(
                      "el-select",
                      {
                        ref: "danUNNo",
                        attrs: {
                          disabled: !_vm.isEditing,
                          placeholder: !_vm.isEditing
                            ? ""
                            : _vm.$t("CargoMsg.Cargo_PleaseSelect"),
                          filterable: "",
                          clearable: "",
                          "allow-create": true
                        },
                        on: {
                          blur: function($event) {
                            return _vm.txtdDnUNNoFocusOutHandler()
                          }
                        },
                        model: {
                          value: _vm.editObj.danUNNo,
                          callback: function($$v) {
                            _vm.$set(_vm.editObj, "danUNNo", $$v)
                          },
                          expression: "editObj.danUNNo"
                        }
                      },
                      _vm._l(_vm.dangerousGoods, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item.code, value: item.code }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.PACKING") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danPacking,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danPacking", $$v)
                        },
                        expression: "editObj.danPacking"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SeaExport.DangerousGoodsLabel") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danLable,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danLable", $$v)
                        },
                        expression: "editObj.danLable"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.EMS") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danEMS,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danEMS", $$v)
                        },
                        expression: "editObj.danEMS"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.Point") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danPoint,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danPoint", $$v)
                        },
                        expression: "editObj.danPoint"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "bold",
                    attrs: { label: _vm.$t("SpecialGoods.Isolation") }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danIsolation,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danIsolation", $$v)
                        },
                        expression: "editObj.danIsolation"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SeaExport.MedicalEmergencyGuideNo")
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.danMfagNo,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danMfagNo", $$v)
                        },
                        expression: "editObj.danMfagNo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.man24") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.dan24man,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "dan24man", $$v)
                        },
                        expression: "editObj.dan24man"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.tel24") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: !_vm.isEditing },
                      model: {
                        value: _vm.editObj.dan24tel,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "dan24tel", $$v)
                        },
                        expression: "editObj.dan24tel"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "column",
                  "margin-left": "20px"
                },
                attrs: {
                  "label-width": "120px",
                  "label-position": "left",
                  disabled: !_vm.isEditing
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.ResponsibleParty") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      model: {
                        value: _vm.editObj.responsibleParty,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "responsibleParty", $$v)
                        },
                        expression: "editObj.responsibleParty"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.HSCODE") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      model: {
                        value: _vm.editObj.hsCode,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "hsCode", $$v)
                        },
                        expression: "editObj.hsCode"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.PickTime") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      model: {
                        value: _vm.editObj.danPickTime,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danPickTime", $$v)
                        },
                        expression: "editObj.danPickTime"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.SeaPullution") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        placeholder: !_vm.isEditing
                          ? ""
                          : _vm.$t("SpecialGoods.OnlyEnterYN")
                      },
                      on: { change: _vm.limitInput },
                      model: {
                        value: _vm.editObj.danSeaPullution,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "danSeaPullution", $$v)
                        },
                        expression: "editObj.danSeaPullution"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SpecialGoods.CorrectTransportName")
                    }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      model: {
                        value: _vm.editObj.correctTransportName,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "correctTransportName", $$v)
                        },
                        expression: "editObj.correctTransportName"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.GrossWeight") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        min: 0,
                        max: 999999999999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.editObj.grossWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "grossWeight", $$v)
                        },
                        expression: "editObj.grossWeight"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.NeatWeight") } },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        min: 0,
                        max: 999999999999,
                        precision: 3,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.editObj.neatWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "neatWeight", $$v)
                        },
                        expression: "editObj.neatWeight"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SpecialGoods.OuterPackagingType") }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      model: {
                        value: _vm.editObj.outerPackagingType,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "outerPackagingType", $$v)
                        },
                        expression: "editObj.outerPackagingType"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SpecialGoods.OuterPackagingQuantity")
                    }
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        min: 0,
                        max: 999999999999,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.editObj.outerPackagingQuantity,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "outerPackagingQuantity", $$v)
                        },
                        expression: "editObj.outerPackagingQuantity"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: _vm.$t("SpecialGoods.InnerPackagingType") }
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        placeholder: !_vm.isEditing
                          ? ""
                          : _vm.$t("SpecialGoods.ThisFieldRequired")
                      },
                      model: {
                        value: _vm.editObj.innerPackagingType,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "innerPackagingType", $$v)
                        },
                        expression: "editObj.innerPackagingType"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("SpecialGoods.InnerPackagingQuantity")
                    }
                  },
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        min: 0,
                        max: 999999999999,
                        precision: 0,
                        "controls-position": "right"
                      },
                      model: {
                        value: _vm.editObj.innerPackagingQuantity,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "innerPackagingQuantity", $$v)
                        },
                        expression: "editObj.innerPackagingQuantity"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.Remark") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: { type: "textarea", rows: 2 },
                      model: {
                        value: _vm.editObj.remark,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "remark", $$v)
                        },
                        expression: "editObj.remark"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SpecialGoods.PackingCode") } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      model: {
                        value: _vm.editObj.packingCode,
                        callback: function($$v) {
                          _vm.$set(_vm.editObj, "packingCode", $$v)
                        },
                        expression: "editObj.packingCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("special-goods-dialog", {
        attrs: {
          visible: _vm.specialGoodsDialog.visible,
          "a-data": _vm.specialGoodsDialog.aData,
          "o-job": _vm.specialGoodsDialog.oJob,
          job: _vm.specialGoodsDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.specialGoodsDialog, "visible", $event)
          },
          refreshCache: _vm.refreshCache
        }
      }),
      _c("imdg-code-select-dialog", {
        attrs: {
          visible: _vm.imdgCodeSelDialog.visible,
          "imdg-codes": _vm.imdgCodeSelDialog.imdgCodes
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.imdgCodeSelDialog, "visible", $event)
          },
          onImdgCodeSelSucceed: _vm.onImdgCodeSelSucceed
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }